import * as R from 'ramda'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { createPortal } from 'react-dom'

const Container = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .iframe-container {
    flex-grow: 1;
    width: 100%;
  }

  .iframe-container iframe {
    display: block;
  }
`
function IFrame({ children, ...props }) {
  const [contentRef, setContentRef] = useState(null)
  const [mountNode, setMountNode] = useState(null)
  const [isReadyForFirefox, setIsReadyForFirefox] = useState(false)
  useEffect(() => {
    if (isReadyForFirefox || contentRef) {
      setMountNode(R.path(['contentWindow', 'document', 'body'], contentRef))
    }
  }, [isReadyForFirefox, contentRef])

  return (
    <Container>
      <div className="iframe-container">
        <iframe
          ref={setContentRef}
          frameBorder="0"
          allowFullScreen
          sandbox="allow-same-origin"
          data-role="desktop-preview"
          width="100%"
          onLoad={() => setIsReadyForFirefox(true)}
          {...props}
        >
          {mountNode && createPortal(children, mountNode)}
        </iframe>
      </div>
    </Container>
  )
}

export default IFrame



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IFrame/index.js